/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createInventoryItemDataSchema = z.object({
	catalogueItemId: z.string().uuid(),
	valueCents: z.number(),
	quantity: z.number(),
	description: z.string(),
	expiresAt: z.iso.datetime(),
})

export type CreateInventoryItemDataSchema = z.infer<typeof createInventoryItemDataSchema>
